import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

export const fetchGovernmentServices = (annex) =>
  getNetwork().get(`${API_ROOT}/edu-service-registry/annex-report-creation`, { params: { annex } });
export const fetchReportsByAnnex = (annex) =>
  getNetwork().get(`${API_ROOT}/edu-report/annex`, { params: { annex } });
export const fetchEventServices = () => getNetwork().get(`${API_ROOT}/edu-activity/report-creation`);
export const fetchSaveReportCreation = (data) => getNetwork().post(`${API_ROOT}/edu-report`, data);
export const fetchUploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return getNetwork().post(
    `${API_ROOT}/files/edu-activity-report`,
    formData,
  );
};

export const fetchFileById = (id) => getNetwork().get(`${API_ROOT}/files/${id}`);
export const fetchRemoveFileById = (id) => getNetwork().delete(`${API_ROOT}/files/${id}`);